import styled  from 'styled-components';

import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const ChannelsWrapper = styled.span`
    margin-top: 24px;
    display: inline-flex;
    white-space: pre;
`;

export const ChannelsLink = styled(H4)`
    color: ${COLORS.Link};
    margin-left: 6px;
    cursor: pointer;
`;
